import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/Layout.vue'

import goTo from 'vuetify/lib/services/goto'

//import store from '@/store'

// Pages.
import ErrorPage from '@/views/ErrorPage.vue'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Pipeline from '@/views/Pipeline.vue'

Vue.use(VueRouter)

const routes = [
  {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        onlyNotLogged: true
      }
  },
  {
    path: '/',
    name: 'layout',
    component: Layout,
    meta: {
      onlyLogged: true
    },
    children: [
        {
            path: 'home',
            name: 'home',
            component: Home
        },
        {
            path: 'pipeline/:id',
            name: 'pipeline',
            component: Pipeline
        },
        {
            path: 'error',
            name: 'error',
            component: ErrorPage
        }
      ]
  }
]

const scrollBehavior = (to)=>{
    if (to.hash)
        return goTo(to.hash)
    
    return goTo(0)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior
})

router.afterEach((/*to, from*/) => {
  
})

/**
 * 🔒 Auth Gateway.
 */
router.beforeEach((to, from, next) => {

  const loggedIn = localStorage.getItem('user')

  // auth check
  if (to.matched.some(record => record.meta.onlyLogged) && !loggedIn) {
    next('/login')
    return
  }

  if (to.matched.some(record => record.meta.onlyNotLogged) && loggedIn) {
    next('/home')
    return
  }

  next()

})

export default router